import { fromEvent, map } from "rxjs";

export default class ContactMethodDropdown {
  constructor() {
    this.selectedValue = '';
    this.id = 'nhs-preferred-contact-method';
    this.labelClassName = '';
    this.fieldClassName = 'form__select';
    this.errorClassName = 'form__error';
    this.errorMessageId = 'nhs_ErrorForPreferredContactMethod';
    this.errorCssClass = 'error';
  }

  set value(newValue) {
    this.selectedValue = newValue || '';
    const node = this.getNode();
    if (node) {
      node.value = this.selectedValue;
    }
  }

  get value() {
    return this.selectedValue;
  }

  /**
   * Overrides the CSS classes used by getHtml(). Defaults match the rest of this feature's
   * form__* system; GetMoreInformationForm (NHS20-8178) overrides them with the nhs-c-input__*
   * component classes.
   * @param {Object} classNames
   * @param {string} [classNames.labelClassName]
   * @param {string} [classNames.fieldClassName]
   * @param {string} [classNames.errorClassName]
   */
  setClassNames({ labelClassName, fieldClassName, errorClassName } = {}) {
    if (labelClassName !== undefined) { this.labelClassName = labelClassName; }
    if (fieldClassName !== undefined) { this.fieldClassName = fieldClassName; }
    if (errorClassName !== undefined) { this.errorClassName = errorClassName; }
  }

  getHtml() {
    return `<label for="${this.id}" class="${this.labelClassName}">Preferred contact method</label>
      <div class="nhs-u-width--full">
        <select id="${this.id}" class="${this.fieldClassName}" autocomplete="off" name="preferredContactMethod" data-qa="preferredContactMethod">
          <option value="" style="display: none;">Select</option>
          <option value="Email" data-qa="preferredContactMethodEmail">Email</option>
          <option value="Phone" data-qa="preferredContactMethodPhone">Phone</option>
          <option value="Text Message" data-qa="preferredContactMethodText">Text</option>
        </select>
        <span id="${this.errorMessageId}" class="${this.errorClassName}" hidden>
                           Please make a selection
                         </span>
      </div>`;
  }

  getNode() {
    return document.getElementById(this.id);
  }

  /**
   * setSelectedValue: Finds the correct index based on the selectedValue
   * and updates the select element.
   */
  setSelectedValue() {
    const node = this.getNode();
    if (node) {
      const optionsArray = Array.from(node.options);
      node.selectedIndex = optionsArray.findIndex((option) => option.value === this.selectedValue);
    }
  }

  /**
   * getOnChangeEvent: On select change map its value to the storage property.
   */
  getOnChangeEvent() {
    return fromEvent(this.getNode(), 'change').pipe(
      map((event) => {
        this.value = event.target.value;
        return { preferredContactMethod: this.selectedValue };
      })
    );
  }

  setInvalidState(node) {
    const errorMessage = document.getElementById(this.errorMessageId);

    node.setAttribute('aria-invalid', true);
    node.classList.add(this.errorCssClass);
    errorMessage.removeAttribute('hidden');
  }

  setValidState(node) {
    const errorMessage = document.getElementById(this.errorMessageId);

    node.removeAttribute('aria-invalid');
    node.classList.remove(this.errorCssClass);
    errorMessage.setAttribute('hidden', true);
  }

  /**
   * Not required per Figma (no asterisk on the label) — always resolves true, but still clears
   * any stale invalid state left over from a prior interaction. Kept as a method, not removed, so
   * GetMoreInformationForm can validate every field the same way.
   */
  validate() {
    const node = this.getNode();
    if (node) {
      this.setValidState(node);
    }
    return Promise.resolve(true);
  }
}
